<template>
    <div class="bg" style="height:100vh;overflow-y: hidden;">
        <div style="background-color:#FFFFFF;height:calc(100vh - 200px);z-index:1">
            <div style="text-align:center;padding-top:40px">
                <div style="font-size:24px;color:#412791">{{merchantName}}</div>
                <div style="padding-top:20px;color:#7F7F7F;font-size:16px">供应商注册</div>
                <div style="font-size:12px;color:#8A81E2">SUPPLIER&nbsp;SYSTEM&nbsp;REGISTERED</div>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;margin-top:0px;background-color:#FFF">
                <mu-text-field v-model="name" placeholder="请输入公司名称" color="#4935ae" icon=":icon iconzongbu"></mu-text-field>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;margin-top:0px;background-color:#FFF">
                <mu-text-field v-model="linker" placeholder="请输入联系人名称" color="#4935ae" icon=":icon iconshoujizhanghao"></mu-text-field>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;margin-top:0px;background-color:#FFF">
                <mu-text-field v-model="phone" placeholder="请输入联系人电话" color="#4935ae" icon=":icon icondianhua1"></mu-text-field>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;margin-top:0px;background-color:#FFF">
                <mu-text-field v-model="address" placeholder="请输入联系地址" color="#4935ae" icon=":icon icondizhi"></mu-text-field>
            </div>
            <div  style="margin-top: 10px;padding:10px;text-align:center;background-color:#FFF;">
                <div class="button" @click="submit">
                    <span><i class="icon iconyanzheng" style="color: #eee;font-weight: 500;padding-right: 15px;font-size:20px;"></i>&nbsp;&nbsp;</span>
                    <span style="color: #FFF;font-weight: 500;font-size: 17px;">注册</span>
                </div>
            </div>
            <div  style="padding:10px;text-align:right;padding-bottom:50px" >
                    <span style="margin-right: 35px;color: #4935ae;font-weight: 500;font-size: 13px;border-bottom:1px solid #4935ae" @click="goBack">已注册，马上登录</span>
            </div>
        </div>
        <div class="bottm">
            <img src="./../assets/images/login-bg.png" style="width:100%">
            <div style="position: absolute;text-align:center;line-height:25px;color:#666">
                <div style="color:#333">千为系统提供服务</div>
                <div>西安秦晔信息技术有限公司</div>
                <div><i class="icon icondianhua1"></i> &nbsp;029-86333499</div>
            </div>
        </div>
        <van-dialog v-model="showDialog" title="注册成功" @confirm="goBack">
            <div style="padding:15px;font-size:15px;font-size:13px;line-height:30px">
                <div style="color:#888;text-align:center">您的账号信息如下，请妥善保管</div>
                <div style="color:#666">账号：{{phone}}</div>
                <div style="color:#666">密码：{{password}}（默认为手机号后6位）</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    data(){
        return {
            showDialog:false,
            name:"",
            linker:"",
            phone:"",
            address:"",
            code:"",
            account:'',
            password:'',
            visibility:false,
            initData:JSON.parse(window.localStorage.getItem("account")),
            merchantName:''

        }
    },
    created(){
        this.$request.post("index/merchantInfo",{accessKey:this.initData.accessKey}).then(data=>{
            if(data.status==200){
                this.merchantName=data.content.merchantName
                this.initData.businessId=data.content.businessId
                this.initData.businessType=data.content.businessType
            }
        })
    },
    methods:{
        goBack(){
            this.showDialog=false
            this.router.go(-1)
        },  
        submit(){
            if(!this.name){
                Toast.fail("请输入公司名称")
                return;
            }
            if(!this.linker){
                Toast.fail("请输入联系人名称")
                return;
            }
            if(!this.phone){
                Toast.fail("请输入联系人电话")
                return;
            }
            var myreg=/^1[3-9]\d{9}$/;
            if (!myreg.test(this.phone)) {
                Toast.fail("请输入正确手机号")
                return;
            }
            this.passwor=this.phone.substr(this.phone.length-6)
            const toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '处理中,请稍候...',
            });
            let formData={
                name:this.name,
                linker:this.linker,
                phone:this.phone,
                address:this.address,
                account:this.phone,
                password:this.phone.substr(this.phone.length-6),
                nickName:this.initData.nickName,
                headImg:this.initData.headImg,
                accessKey:this.initData.accessKey,
                businessId:this.initData.businessId,
                businessType:this.initData.businessType,
                appId:this.initData.appId,
                unionId:this.initData.unionId,
                openId:this.initData.openId,
            }
            this.$request.post("register",formData).then(data=>{
                Toast.clear()
                if(data.status==200){
                    this.showDialog=true;
                    
                }else{
                    if(data.message=='token 不存在请重新授权'){
                        localStorage.removeItem("token")
                        window.location.href = "https://" + window.location.host + "/wxgzh/supplier?accessKey=" + this.initData.accessKey;
                    }
                    Toast.fail(data.message);
                }
            })
        }
    }
}
</script>

<style>
    .button{
        background-color: #4935ae;
        display: flex;
        align-items: center;
        height:46px;
        justify-content: center;
        padding: 4px 24px;
        width: 80%;
        margin-left: 10%;
        border-radius: 5px;
    }
    .bottm{
        width: 100%;
        position: relative;
        z-index: -1;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/views/Regist.vue